import { saveBlobAsFile } from 'shared/file/saveBlobAsFile'
import { isAxiosError } from 'shared/api/isAxiosError'
import { getErrorMessage } from '../../../../helpers/errors.helper'
import { extractFileNameFromContentPositionHeader } from '../../../../helpers/axios-header.helper'
import { ErrorResponse } from '../../../../shared/api/parseAxiosTransitErrorResponse'
import { ApiError } from '../../../../errors/ApiError'
import { fetchSubmissionMessageV2 } from '../api/http'

function useGenerateSubmitMessage() {
  const generateSubmissionMessage = async (transitOperationId: number): Promise<void> => {
    try {
      const response = await fetchSubmissionMessageV2({
        id: transitOperationId,
        currencyExchangeRate: 0,
      })

      const { data } = response

      const filename = extractFileNameFromContentPositionHeader(response)

      saveBlobAsFile(data, filename)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      if (isAxiosError<Blob>(e)) {
        const responseData = e.response?.data
        if (responseData instanceof Blob) {
          const errorResponse = JSON.parse(await responseData?.text()) as ErrorResponse

          throw new ApiError(errorResponse.message, {
            status: e.response?.status,
            traceId: e.response?.headers['x-trace-id'] ?? undefined,
            details: errorResponse,
          })
        }
      }

      throw new Error(getErrorMessage(e) ?? 'Error occurred when generating submission message')
    }
  }

  return {
    generateSubmissionMessage,
  }
}

export default useGenerateSubmitMessage
